import { GET_GOLFCOURSE } from '@/constants/member_card';
import { GET_GOLFCOURSE_SELECE_LIST } from '@/constants/golf_course';

export const golfCourseMixin = {
    data () {
        return {
            error: '',
            golfSelect: '',
            golfCode: ''
        };
    },
    methods: {
        getGolfCourse () {
            return this.$apollo.mutate({
                mutation: GET_GOLFCOURSE,
                variables: { golf_group_code: this.golfGroupCode }
            }).then(res => {
                this.data = res.data.getGolfCourse;
                this.data.forEach(data => {
                    this.golfSelect.push(data);
                });
                return this.data[0].golf_code;
            });
        },
        /** --------------------------------------------
        * ゴルフ場セレクトボックスを取得する。
        * -------------------------------------------- */
        async getGolfCourseList () {
            const res = await this.$apollo.query({
                query: GET_GOLFCOURSE_SELECE_LIST,
                fetchPolicy: 'no-cache',
                variables: {
                    golf_group_code: process.env.VUE_APP_GROUP_CODE,
                    golf_code: this.admin.golf_code,
                    user_id: this.admin.user_id
                }
            });
            return res.data.GolfCourseSelectList;
        }
    }
};
